import { useEffect, useRef, useState } from 'react';

export const useCarousel = (slidesInView, totalSlides, options) => {
  const [current, setCurrent] = useState(0);

  const ref = useRef(null);

  const next = () => {
    if (options?.oneByOneSteps) {
      setCurrent((current + 1) % (totalSlides - slidesInView + 1));
    } else {
      setCurrent((current + slidesInView) % (totalSlides + 1));
    }
  };

  const prev = () => {
    if (options?.oneByOneSteps) {
      setCurrent((totalSlides - slidesInView + current) % (totalSlides - slidesInView + 1));
    } else if (current < slidesInView) {
      setCurrent((current + totalSlides - slidesInView + 1) % (totalSlides + 1));
    } else {
      setCurrent(current - slidesInView);
    }
  };

  const desired = (e) => {
    setCurrent(Number(e.target.id));
  };

  useEffect(() => {
    if (ref.current) {
      const transformDegree = (100 / slidesInView) * current;
      ref.current.style.transition = 'all 0.2s ease-in-out';
      ref.current.style.transform = `translateX(+${transformDegree}%)`;
      ref.current.style.width = `${slidesInView * 250}px`;
    }
  }, [current, totalSlides]);

  return {
    current,
    desired,
    ref,
    prev,
    next,
  };
};
